import { render, staticRenderFns } from "./VuesticAlert.vue?vue&type=template&id=525da77a&scoped=true"
import script from "./VuesticAlert.vue?vue&type=script&lang=js"
export * from "./VuesticAlert.vue?vue&type=script&lang=js"
import style0 from "./VuesticAlert.vue?vue&type=style&index=0&id=525da77a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525da77a",
  null
  
)

export default component.exports